import { Typography } from '@mui/material';
import type { ComponentPropsWithoutRef, Key, PropsWithChildren, ReactNode } from 'react';
import React from 'react';
import { useTranslation } from 'next-i18next';

import { colours } from 'src/constants/colours';
import { styledComponent, styledTag } from 'src/utils/styled';

export const adDetailWrapperAlignmentCSS = `
    flex-wrap: wrap;
    display: flex;
    gap: 0rem 0.5rem ;
    & p {
        display:inline-block;
    }`;

export const StyledListItem = styledTag('li')`
    ${adDetailWrapperAlignmentCSS}
    margin: 0;
    list-style:none;
    align-items: baseline;
    color: ${colours.primary.O87}
`;

const StyledTypography = styledComponent(Typography)<{ component?: string }>`
    line-height: 1.125rem;
`;

export type AdDetailWrapper = React.FC<PropsWithChildren<{ key: Key | null | undefined; after?: ReactNode }>>;
export type AdDetailProps = {
    leftText: string;
    rightText: string | number | undefined | null;
    dataTestId: string;
    condition?: boolean;
    wrapper?: AdDetailWrapper;
    after?: ReactNode;
    leftProps?: ComponentPropsWithoutRef<typeof Typography>;
    rightProps?: ComponentPropsWithoutRef<typeof Typography>;
};

const AdDetail = ({
    leftText,
    rightText,
    dataTestId,
    condition = true,
    wrapper,
    after,
    leftProps,
    rightProps,
}: AdDetailProps) => {
    const { t } = useTranslation();
    const Wrapper = wrapper ?? StyledListItem;
    return condition ? (
        <Wrapper key={dataTestId} data-target-id={`${dataTestId}-wrapper`}>
            <StyledTypography
                data-target-id={dataTestId}
                sx={{
                    fontSize: '0.875rem',
                    fontWeight: 400,
                }}
                component="span"
                {...leftProps}
            >
                {leftText}
                <StyledTypography
                    sx={{ fontSize: '1rem', fontWeight: 700, ml: '0.5rem' }}
                    component="span"
                    data-target-id={`${dataTestId}-right`}
                    {...rightProps}
                >
                    {rightText}
                </StyledTypography>
                {Boolean(after) && <br />}
                {after}
            </StyledTypography>
        </Wrapper>
    ) : null;
};

export default AdDetail;
